<div class="releases-detail-container" *ngIf="song">
  <!-- <span class="breadcrumb-item pointer" (click)="goBack()">Go Back</span> -->

  <div class="col-12">
    <div style="font-size:11px;line-height:16.5px;font-weight:400;font-family:Poppins;color:#989AA3 !important;"
      class="breadcrumbfont">
      <sd-breadcrumb [data]="{
    'breadcrumb': [
      {
        'name': 'My Release',
        'link': '/distribute/my-releases'
      },
      {
        'name': (global.isMobile() && song.title.length > 10)
          ? (song.title | slice:0:10) + '...'
          : song.title
      }
    ],
    'version': 2
  }">
      </sd-breadcrumb>
      <sd-content-banner class="block m-t-20"></sd-content-banner>
    </div>
  </div>

  <div class="detail-hero-panel mb-4">
    <div class="hero-panel-grid">

      <div class="detail-artwork-wrapper">
        <img [lazyLoad]="song?.image + '?w-300'" class="detail-artwork-img"
          defaultImage="https://songdewnetwork.com/sgmedia/assets/images/default-album-art.png" [alt]="song.title" />
      </div>

      <div class="hero-details-col d-flex flex-column">

        <div class="hero-title-group mb-2">
          <span class="badge-type d-block" [ngClass]="song.album_id == 0 ? 'badge-single' : 'badge-album'">
            {{ song.album_id == 0 ? 'Single' : 'Album' }}
          </span>

          <h4 class="songTitleText mb-0">
            {{ (global.isMobile() && song.title.length > 10) ? (song.title | slice:0:10) + '...' : song.title }}
          </h4>

          <p class="detail-song-artist mb-0" *ngIf="artistNames">
            {{ artistNames }}
          </p>
        </div>


        <div class="hero-status-row d-flex align-items-center mb-2" [ngClass]="getDistributionStatusClass()">
          <span class="hero-status-icon mr-2" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#A0A0A0" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M2.5 15V10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10V15">
              </path>
              <path
                d="M17.5 15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H15C14.558 17.5 14.134 17.3244 13.8215 17.0118C13.5089 16.6993 13.3333 16.2754 13.3333 15.8333V13.3333C13.3333 12.8913 13.5089 12.4674 13.8215 12.1548C14.134 11.8423 14.558 11.6667 15 11.6667H17.5V15.8333ZM2.5 15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H5C5.44203 17.5 5.86595 17.3244 6.17851 17.0118C6.49107 16.6993 6.66667 16.2754 6.66667 15.8333V13.3333C6.66667 12.8913 6.49107 12.4674 6.17851 12.1548C5.86595 11.8423 5.44203 11.6667 5 11.6667H2.5V15.8333Z">
              </path>
            </svg>
          </span>
          <span class="hero-status-separator mr-1">&bull;</span>
          <span class="hero-status-text">{{ getDistributionStatus() }}</span>
        </div>

        <div class="d-flex align-items-center hero-meta-row mb-0">
          <span class="infoText">Release : {{ song.agreement < 1 ? global.formatedDate(song.created_date) :
              global.formatedDate(song.release_date) }}</span>
              <span class="hero-meta-separator mx-2">&bull;</span>
              <span class="infoText">{{ song.album_id == 0 ? '1 Track' : song.pdlIssue?.length + ' Tracks' }}</span>
        </div>

      </div>

      <div class="detail-hero-actions-row d-flex align-items-center">
        <button class="button mr-2" *ngIf="getDistributionStatus() === 'Drafts'" (click)="completeRelease()">
          Complete Release
        </button>

        <button class="button mr-2"
          *ngIf="getDistributionStatus() !== 'Drafts' && getDistributionStatus() !== 'Terminated' && getDistributionStatus() !== 'On hold'"
          [disabled]="song.agreement < 1" routerLink="/promote/{{song.album_id == 0 ? 'song': 'album'}}/{{song.slug}}"
          (click)="global.gAEvents('my_release', 'promote_button', song.title, song.album_id == 0 ? 'single' : 'album')">
          Promote
        </button>
      </div>

    </div>
  </div>


  <div class="detail-section stepper-section py-3 border-bottom mb-4" *ngIf="song.distribution_status && song.distribution_status.length > 0 && 
              getDistributionStatus() !== 'Drafts' && 
              getDistributionStatus() !== 'Live' && 
              getDistributionStatus() !== 'Terminated' && 
              getDistributionStatus() !== 'On hold'">
    <div class="progress-container">
      <div *ngFor="let item of song.distribution_status; let j = index" class="step" [ngClass]="{
             'completed': song.distribution_status[j]?.on && song.distribution_status[j+1]?.on,
             'active': song.distribution_status[j]?.on && !song.distribution_status[j+1]?.on,
             'terminatedIcon': item.status === 'Terminated'
           }">

        <div class="circle">
          <div *ngIf="item.on" class="dot"></div>
        </div>
        <p class="labelText">{{ item.status }}</p>
      </div>
    </div>


    <div class="stepper-warning-card d-flex align-items-center justify-content-between mt-4 p-3 rounded"
      *ngIf="hasIssue()">
      <div class="stepper-warning-content d-flex align-items-start">
        <img src="../../../assets/images/issue-alert-icon.svg" class="warning-icon mr-2" width="15" height="15" />
        <div class="warning-text-col">
          <span class="warning-text d-block">{{ getIssueHeadline() }}</span>

          <div class="warning-message d-flex align-items-start" *ngFor="let message of getIssueMessages()">
            <span class="issue-message-bar mr-2"></span>
            <span>{{ message }}</span>
          </div>
        </div>
      </div>

      <button type="button" class="btn-upload-video ml-3 flex-shrink-0" *ngIf="canUploadFix()"
        [routerLink]="'/distribute/release-issue'"
        [queryParams]="{ slug: song.slug, isalbum: song.album_id > 0 ? 1 : 0 }">
        Upload Image
      </button>
    </div>
  </div>


  <div class="panels-list">


    <div class="detail-section track-details-section mb-3">
      <div class="panel-heading-row">
        <h3 class="panel-section-title text-uppercase">Track Details</h3>
        <div class="panel-heading-divider"></div>
      </div>

      <div class="track-upc-row" *ngIf="song.upc">
        <span class="track-detail-label">UPC : {{ song.upc }}</span>
      </div>

      <div class="track-details-table">

        <div class="track-detail-header d-flex align-items-center justify-content-between">
          <span class="track-detail-label track-name-col">Track Name</span>
          <span class="track-detail-label track-isrc-col">ISRC</span>
        </div>

        <ng-container *ngFor="let track of song.pdlIssue; let j = index">


          <div class="track-issue-wrapper d-flex align-items-center justify-content-between mb-2 flex-wrap"
            *ngIf="track.issue?.length > 0">
            <div class="track-issue-content flex-grow-1">
              <ng-container *ngTemplateOutlet="trackRow"></ng-container>
              <div class="track-issue-message d-flex align-items-center mt-2">
                <span class="issue-message-bar mr-2"></span>
                <span>{{ track.issue[0]?.msg }}</span>
              </div>
            </div>
            <button type="button" class="btn-upload-video flex-shrink-0 mt-2 mt-md-0"
              [routerLink]="'/distribute/release-issue'"
              [queryParams]="{ slug: song.slug, isalbum: song.album_id > 0 ? 1 : 0, title: track.title }">
              Upload Audio
            </button>
          </div>

          <ng-container *ngIf="!(track.issue?.length > 0)">
            <ng-container *ngTemplateOutlet="trackRow"></ng-container>
          </ng-container>

          <ng-template #trackRow>
            <div class="track-detail-data-row d-flex align-items-center justify-content-between flex-nowrap">
              <span class="track-detail-value track-name-col">{{ track.title }}</span>
              <span class="track-detail-value track-isrc-col">{{ getTrackIsrc(track) }}</span>
            </div>
          </ng-template>

        </ng-container>
      </div>
    </div>


    <div class="detail-section rights-section mb-3"
      *ngIf="getDistributionStatus() !== 'Drafts' && (song.signed_agreement || song.processedAgreements?.length)">
      <div class="panel-heading-row">
        <h3 class="panel-section-title">RIGHTS</h3>
        <div class="panel-heading-divider"></div>
      </div>

      <div class="rights-icons-row d-flex align-items-center">
        <div class="rights-icon-item pointer" *ngIf="song.signed_agreement || distAgreement" (click)="openPdf(song)">
          <img src="../../../assets/images/rights-distribution-icon.svg" alt="Distribution" />
        </div>
        <div class="rights-icon-item rights-icon-circle pointer" *ngIf="pubAgreement"
          (click)="openAgreement(pubAgreement, pubIndex)">
          <img src="../../../assets/images/rights-publishing-icon.svg" class="rights-icon-glyph" alt="Publishing" />
        </div>
        <div class="rights-icon-item rights-icon-circle pointer" *ngIf="syncAgreement"
          (click)="openAgreement(syncAgreement, syncIndex)">
          <img src="../../../assets/images/rights-sync-icon.svg" class="rights-icon-glyph" alt="Sync" />
        </div>
      </div>
    </div>


    <div class="detail-section availability-section mb-3"
      *ngIf="getDistributionStatus() !== 'Drafts' && getAvailabilityPlatforms().length > 0">
      <div class="panel-heading-row">
        <h3 class="panel-section-title">AVAILABILITY</h3>
        <div class="panel-heading-divider"></div>
      </div>

      <div class="platforms-list d-flex align-items-center">
        <ng-container *ngFor="let pf of getAvailabilityPlatforms()">
          <a [href]="pf.url" target="_blank" rel="noopener noreferrer" class="mr-2">
            <img [src]="platformIcons[pf.name]" [alt]="pf.name + ' Icon'" width="24px" />
          </a>
        </ng-container>
        <span class="availability-more-text">+ 147 Platforms</span>
      </div>
    </div>


    <div class="detail-section enhance-release-section mb-3"
      *ngIf="getDistributionStatus() !== 'Drafts' && getDistributionStatus() !== 'Terminated'">
      <div class="panel-heading-row">
        <h3 class="panel-section-title text-uppercase">Enhance Your Release</h3>
        <p class="enhance-subtitle">Take your release further with these optional services.</p>
        <div class="panel-heading-divider"></div>
      </div>

      <div class="service-block">
        <div class="service-header-row">
          <div class="service-header d-flex align-items-center flex-wrap">
            <img src="../../../assets/logos/spotify.png" class="service-icon mr-3" width="31" height="31"
              alt="Spotify" />
            <div class="service-title-group flex-grow-1">
              <div class="d-flex align-items-center">
                <span class="service-title">Spotify Video Release</span>
              </div>
              <p class="service-desc mb-0">Add your official music video and give this release a richer story on
                Spotify.</p>
            </div>
          </div>

          <div class="service-meta-row d-flex align-items-center"
            [class.pointer]="song.pdlIssue?.length > 1"
            (click)="song.pdlIssue?.length > 1 && (isEnhanceExpanded = !isEnhanceExpanded)">
            <span class="service-meta mr-3">{{ song.pdlIssue?.length }} {{ song.pdlIssue?.length === 1 ? 'Track' :
              'Tracks' }} &bull; &#8377;{{ videoReleasePrice }} per track, one time</span>
            <span class="service-chevron" *ngIf="song.pdlIssue?.length > 1"
              [class.service-chevron-collapsed]="!isEnhanceExpanded">
              <svg width="20" height="20" viewBox="0 0 33 33" fill="none" stroke="#A0A0A0" stroke-width="2.475"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M8.25 20.625L16.5 12.375L24.75 20.625"></path>
              </svg>
            </span>
          </div>
        </div>

        <ng-container *ngIf="isEnhanceExpanded">
          <div class="panel-heading-divider mb-2"></div>

          <ng-container *ngFor="let track of song.pdlIssue; let j = index; let last = last">
            <ng-container *ngIf="getVideoReleaseStatus(track) as vStatus">
              <div class="service-track-row d-flex align-items-center flex-wrap"
                [class.has-action]="vStatus.state !== 'in_process' && vStatus.state !== 'live' && vStatus.state !== 'terminated'">
                <span class="service-track-name">{{ (global.isMobile() && track.title.length > 10) ?
                  (track.title | slice:0:10) + '...' : track.title }}</span>

                <div
                  class="service-track-status-action d-flex align-items-center justify-content-between flex-grow-1 flex-wrap">
                  <div class="service-track-status-group d-flex align-items-center">
                    <span class="service-track-icon mr-2" [ngSwitch]="vStatus.state">
                      <img *ngSwitchCase="'eligible'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <img *ngSwitchCase="'awaiting_form'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <img *ngSwitchCase="'live'" src="../../../assets/images/video-release-eligible-icon.svg" alt=""
                        width="19" height="19" />
                      <img *ngSwitchCase="'completed'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <svg *ngSwitchCase="'in_process'" width="19" height="19" viewBox="0 0 24 24" fill="none"
                        stroke="#E69900" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <svg *ngSwitchCase="'terminated'" width="19" height="19" viewBox="0 0 24 24" fill="none"
                        stroke="#A0A0A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                      <svg *ngSwitchCase="'locked'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="#A0A0A0" stroke-width="3">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </span>
                    <div>
                      <span class="service-status-text d-block">{{ vStatus.label }}</span>
                      <p class="service-status-subtext mb-0" *ngIf="vStatus.subLabel">{{ vStatus.subLabel }}</p>
                    </div>
                  </div>

                  <div class="service-track-action">
                    <ng-container
                      *ngIf="vStatus.state === 'eligible' || vStatus.state === 'awaiting_form'; else serviceActionDisabled">
                      <button class="btn-upload-video w-100-mobile" (click)="payForVideoRelease(track)">
                        {{ vStatus.state === 'eligible' ? 'Pay & Upload' : 'Upload' }}
                      </button>
                    </ng-container>
                    <ng-template #serviceActionDisabled>
                      <button class="btn-upload-video w-100-mobile" disabled
                        *ngIf="vStatus.state !== 'in_process' && vStatus.state !== 'live' && vStatus.state !== 'terminated'">
                        Upload video
                      </button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="panel-heading-divider my-3"></div>

      <div class="service-block">
        <div class="service-header-row">
          <div class="service-header d-flex align-items-center flex-wrap">
            <img src="../../../assets/logos/dolby.svg" class="service-icon mr-3" width="31" height="31"
              alt="Dolby Atmos" />
            <div class="service-title-group flex-grow-1">
              <div class="d-flex align-items-center">
                <span class="service-title">Dolby Atmos Release</span>
              </div>
              <p class="service-desc mb-0">Deliver your music in Dolby Atmos spatial audio for an immersive listening experience across streaming platforms.</p>
            </div>
          </div>

          <div class="service-meta-row d-flex align-items-center"
            [class.pointer]="song.pdlIssue?.length > 1"
            (click)="song.pdlIssue?.length > 1 && (isDolbyEnhanceExpanded = !isDolbyEnhanceExpanded)">
            <span class="service-meta mr-3">{{ song.pdlIssue?.length }} {{ song.pdlIssue?.length === 1 ? 'Track' :
              'Tracks' }} &bull; &#8377;{{ dolbyReleasePrice }} per track, one time</span>
            <span class="service-chevron" *ngIf="song.pdlIssue?.length > 1"
              [class.service-chevron-collapsed]="!isDolbyEnhanceExpanded">
              <svg width="20" height="20" viewBox="0 0 33 33" fill="none" stroke="#A0A0A0" stroke-width="2.475"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M8.25 20.625L16.5 12.375L24.75 20.625"></path>
              </svg>
            </span>
          </div>
        </div>

        <ng-container *ngIf="isDolbyEnhanceExpanded">
          <div class="panel-heading-divider mb-2"></div>

          <ng-container *ngFor="let track of song.pdlIssue; let j = index; let last = last">
            <ng-container *ngIf="getDolbyReleaseStatus(track) as dStatus">
              <div class="service-track-row d-flex align-items-center flex-wrap"
                [class.has-action]="dStatus.state !== 'in_process' && dStatus.state !== 'live' && dStatus.state !== 'terminated'">
                <span class="service-track-name">{{ (global.isMobile() && track.title.length > 10) ?
                  (track.title | slice:0:10) + '...' : track.title }}</span>

                <div
                  class="service-track-status-action d-flex align-items-center justify-content-between flex-grow-1 flex-wrap">
                  <div class="service-track-status-group d-flex align-items-center">
                    <span class="service-track-icon mr-2" [ngSwitch]="dStatus.state">
                      <img *ngSwitchCase="'eligible'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <img *ngSwitchCase="'awaiting_form'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <img *ngSwitchCase="'live'" src="../../../assets/images/video-release-eligible-icon.svg" alt=""
                        width="19" height="19" />
                      <img *ngSwitchCase="'completed'" src="../../../assets/images/video-release-eligible-icon.svg"
                        alt="" width="19" height="19" />
                      <svg *ngSwitchCase="'in_process'" width="19" height="19" viewBox="0 0 24 24" fill="none"
                        stroke="#E69900" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <svg *ngSwitchCase="'terminated'" width="19" height="19" viewBox="0 0 24 24" fill="none"
                        stroke="#A0A0A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="16" x2="12" y2="12"></line>
                        <line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                      <svg *ngSwitchCase="'locked'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="#A0A0A0" stroke-width="3">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </span>
                    <div>
                      <span class="service-status-text d-block">{{ dStatus.label }}</span>
                      <p class="service-status-subtext mb-0" *ngIf="dStatus.subLabel">{{ dStatus.subLabel }}</p>
                    </div>
                  </div>

                  <div class="service-track-action">
                    <ng-container
                      *ngIf="dStatus.state === 'eligible' || dStatus.state === 'awaiting_form'; else dolbyActionDisabled">
                      <button class="btn-upload-video w-100-mobile" (click)="payForDolbyRelease(track)">
                        {{ dStatus.state === 'eligible' ? 'Pay & Upload' : 'Upload' }}
                      </button>
                    </ng-container>
                    <ng-template #dolbyActionDisabled>
                      <button class="btn-upload-video w-100-mobile" disabled
                        *ngIf="dStatus.state !== 'in_process' && dStatus.state !== 'live' && dStatus.state !== 'terminated'">
                        Upload
                      </button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>

  </div>
</div>

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content" style="border-radius:18px; border: none; box-shadow: 0 10px 40px rgba(0,0,0,0.12);">
      <div class="modal-header border-0 px-4 pt-4">
        <h5 class="modal-title font-weight-bold text-dark" id="exampleModalLongTitle">Agreement Signature View</h5>
        <img class="close-icon pointer" data-dismiss="modal" alt="Close" (click)="resetOtpStates()"
          src="../../../../assets/image/dashboard/cross_btn.svg" width="24" height="24" />
      </div>
      <div class="modal-body px-4 pb-4" style="max-height: 550px; overflow-y: auto;">


        <div class="agreement-content-box p-3 rounded mb-4 border bg-light"
          style="max-height: 250px; overflow-y: auto; font-size: 13px; line-height: 1.6; color: #4e555b;">
          <span
            [innerHTML]="(selectedAgreementIndex !== null && agreementPreviews?.[selectedAgreementIndex]) ? agreementPreviews[selectedAgreementIndex] : agreementPreview"></span>
        </div>


        <div *ngIf="!isAgreementSigned" class="otp-signing-block border-top pt-3">
          <form [formGroup]="otpForm" novalidate>
            <h4 class="font-weight-bold text-dark mb-2">Sign Contract via WhatsApp OTP</h4>

            <div class="form-group col-md-10 px-0">
              <label class="text-muted text-12 mb-1">Your Registered WhatsApp number</label>


              <div class="d-flex align-items-center mb-3" *ngIf="!editMobileNumber">
                <span class="phone-masked-text font-weight-bold text-16 text-primary">{{ phonenumber }}</span>
                <button [disabled]="otpTimerStart" type="button" class="btn btn-link edit-phone-btn ml-2 p-0"
                  (click)="editOtpNumber()">
                  <img width="18" height="18" alt="Edit" src="../../../assets/profileImageAndIcon/edit.svg" />
                </button>
              </div>


              <div class="mobileinput-wrapper mb-3" *ngIf="editMobileNumber">
                <div class="mobileinput d-flex align-items-center p-2 border rounded bg-white">

                  <span data-toggle="dropdown" class="d-flex align-items-center pointer px-2">
                    <img class="flag mr-1" [lazyLoad]="flagImageUrl + selectedflag + '.svg'"
                      defaultImage="https://songdewnetwork.com/sgmedia/country/default.svg" width="20" />
                    <img src="assets/images/fi_chevron-down-grey.svg" class="arrow-down-icon" width="10" />
                  </span>


                  <div class="dropdown-menu countryFlag-dropdown p-2" style="max-height: 250px; overflow-y: auto;">
                    <input class="form-control form-control-sm mb-2" type="text" placeholder="Search..."
                      #searchCountryCode />
                    <div *ngFor="let country of countries | searchFilter:searchCountryCode.value">
                      <a class="dropdown-item py-1 text-13"
                        (click)="changeSelectedCountryCode(country.code, country.country_code)">
                        <span>{{ country.name }} (+{{ country.country_code }})</span>
                      </a>
                    </div>
                  </div>

                  <input type="tel" class="form-control-num country-code-input border-0 font-weight-bold text-center"
                    formControlName="countryCode" readonly style="width: 60px;" />
                  <input type="tel" class="form-control-num phone-num-input border-0 ml-1 flex-grow-1"
                    formControlName="phone" maxlength="15" placeholder="Mobile number" />
                </div>
              </div>


              <div *ngIf="otpSend" class="otp-inputs-wrapper mb-3">
                <p class="otp-status-info text-success font-weight-bold mb-2">{{ otpSendStatus }}</p>

                <div class="row mx-0 justify-content-between" formGroupName="otp" style="max-width: 320px;">
                  <input type="number" formControlName="input1" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                  <input type="number" formControlName="input2" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                  <input type="number" formControlName="input3" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                  <input type="number" formControlName="input4" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                  <input type="number" formControlName="input5" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                  <input type="number" formControlName="input6" class="form-control-otp text-center" maxlength="1"
                    [readonly]="disabledOTPInput" />
                </div>

                <div class="resend-wrapper mt-2">
                  <button class="btn btn-link btn-resend p-0 text-13" (click)="sendOtp()"
                    [disabled]="otpTimerStart || disabledOTPInput">
                    Resend OTP
                  </button>
                  <span class="timer-countdown text-muted text-13 ml-1" *ngIf="otpTimerStart">
                    ({{ timerMinute }}:{{ timerSecond.toLocaleString('en-US', { minimumIntegerDigits: 2 }) }})
                  </span>
                </div>
              </div>


              <button class="btn btn-primary px-4 btn-otp-action" (click)="sendOtp()" *ngIf="!otpSend"
                [disabled]="otpTimerStart || disabledOTPInput">
                Send OTP
              </button>


              <button class="btn btn-primary px-4 btn-otp-action" (click)="verifyOtp()"
                *ngIf="otpSend && !verifySuccess" [disabled]="disabledOTPInput || !isOtpComplete()">
                Verify OTP
              </button>


              <mat-error class="d-block mt-2" *ngIf="formSubmit && otpSendStatus == '' && !otpSend">
                Please send OTP to verify your WhatsApp number
              </mat-error>
              <mat-error class="d-block mt-2"
                *ngIf="formSubmit && otpSend && (otp?.get('input1').errors?.required || otp?.get('input2').errors?.required || otp?.get('input3').errors?.required || otp?.get('input4').errors?.required || otp?.get('input5').errors?.required || otp?.get('input6').errors?.required)">
                All 6 OTP digits are required.
              </mat-error>
              <mat-error class="d-block mt-2" *ngIf="verifyOTPError">
                {{ finalErrorMsg }}
              </mat-error>
              <div class="text-success mt-2 font-weight-bold" *ngIf="verifySuccess">
                {{ finalErrorMsg }}
              </div>
            </div>
          </form>
        </div>


        <div *ngIf="isAgreementSigned" class="alert alert-success d-flex align-items-center mt-3 border-0 rounded-lg">
          <img src="../../../assets/images/upload/Publishing.svg" width="20" class="mr-2"
            style="filter: brightness(0.2) sepia(1) hue-rotate(100deg);" />
          <span class="font-weight-600">This agreement has been signed digitally.</span>
        </div>

      </div>
    </div>
  </div>
</div>